import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment-timezone'
import AWS from 'aws-sdk'
import { API, Auth, Logger } from 'aws-amplify'
import AmplifyStore from './modules/AmplifyStore'
import _ from 'lodash'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const logger = new Logger('store')
const dynamodbSuffix = process.env.VUE_APP_DYNAMODB_TableSuffix

const state = {
  loggedIn: false,
  token: null,
  currentUser: null,
  currentUserGroup: null,

  users: [],
  userGroups: [],
  userFelicas: []
}

const mutations = {
  onAuthStateChanged (state, { user }) {
    debug && logger.debug('mutations:onAuthStateChanged', user)
    state.currentUser = user
    state.loggedIn = user.uid !== ''
  },
  setUsers (state, { users }) {
    logger.debug('store:mutations:setUsers:', users)
    state.users = users
  },
  setUserGroups (state, { userGroups }) {
    logger.debug('store:mutations:userGroups:', userGroups)
    state.userGroups = userGroups
  },
  setUserFelicas (state, { userFelicas }) {
    logger.debug('store:mutations:setUserFelicas:', userFelicas)
    state.userFelicas = userFelicas
  },
  setUser (state, { user }) {
    logger.debug('store:mutations:setUser:', user)
    var idx = _.findIndex(state.users, (u) => u.user_id === user.user_id)
    Vue.set(state.users, idx, user)
  },
  setUserGroup (state, { userGroup }) {
    logger.debug('store:mutations:setUserGroup:', userGroup)
    var idx = _.findIndex(state.userGroups, (u) => u.groupId === userGroup.groupId)
    Vue.set(state.userGroups, idx, userGroup)
  },
  updateUser (state, { userId, name, value }) {
    logger.debug('store:mutations:updateUser:', userId, name, value)
    var target = _.find(state.users, (u) => u.user_id === userId)
    logger.debug('target', target)
    var names = _.split(name, '.')
    if (names.length === 3) {
      target && Vue.set(target[names[0]][names[1]], names[2], value)
    } else if (names.length === 2) {
      target && Vue.set(target[names[0]], names[1], value)
    } else {
      target && Vue.set(target, names[0], value)
    }
    logger.debug('store:mutations:updateUser:', target)
  },
  setCurrentUser (state, { user }) {
    logger.debug('setCurrentUser:', user)
    state.currentUser = user
  },
  setCurrentUserGroup (state, { userGroup }) {
    state.currentUserGroup = userGroup
  }
}

const actions = {
  async createUser ({ commit, state }, { newUser }) {
    logger.debug('store::createUser', newUser)
    let now = moment().tz('Asia/Tokyo').format('x')
    let params = {
      user_id: newUser.userId,
      currentUserNo: newUser.userNo,
      userGroup: newUser.userGroup,
      gender: newUser.gender,
      birthday: moment(newUser.birthday, 'YYYY-MM-DD').set('date', 1).format('YYYY-MM-DD'),
      age: moment.tz('Asia/Tokyo').diff(newUser.birthday, 'years'),
      heightInCentimeters: newUser.height,
      weightAdjustmentInKilograms: '1.0',
      physicalType: '0',
      enabled: true,
      createdAt: now,
      createdById: AmplifyStore.getters.userId,
      createdByName: AmplifyStore.getters.user.name,
      lastModifiedAt: now
    }
    logger.debug('Dynamodb Key:' + newUser.userId, now)
    logger.debug('params:', params)

    return API.post('thinkss-kenkobus-api', '/users', { body: params, response: true
    }).then(res => {
      logger.debug('store::createUser', res.data)
      if (res.status === 200) {
        if (res.data.errorMessage || res.data.errorType) {
          throw new Error('通信エラー: ' + (res.data.errorMessage || res.data))
        }
        return res.data
      } else {
        logger.error(res)
        throw new Error('response error')
      }
    })
  },
  async createUserDailyEnquetes ({ commit, state }, { user, userGroup, userNo }) {
    logger.debug('store::createUserDailyEnquetes', user, userGroup, userNo)
    let params = user
    user.userNo = userNo
    user.userGroup = userGroup
    user.userGroup.userNo = userNo

    let path = '/users/' + user.user_id + '/health-data/user-daily-enquetes/new'
    return API.post('thinkss-kenkobus-api', path, {
      body: params,
      response: true
    }).then(res => {
      logger.debug('store::createUser', res.data)
      if (res.status === 200) {
        if (res.data.errorMessage || res.data.errorType) {
          throw new Error('通信エラー: ' + (res.data.errorMessage || res.data))
        }
        return res.data
      } else {
        logger.error(res)
        throw new Error('response error')
      }
    })
  },
  async createUserGroup ({ commit, state }, { newGroup }) {
    logger.debug('store::createUserGroup', newGroup)
    let now = moment().tz('Asia/Tokyo').format('x')
    newGroup.idms = []
    newGroup.lastModifiedAt = now
    var params = {
      TableName: 'user_groups' + dynamodbSuffix,
      Item: newGroup,
      ConditionExpression: 'attribute_not_exists(groupId)'
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.put(params).promise()
      })
      .then(data => {
        logger.debug('created:', data)
        return data
      })
  },
  async openUserGroup ({ commit, state }, { groupId }) {
    logger.debug('store::openUserGroup', groupId)
    let now = moment().tz('Asia/Tokyo').format('x')
    var params = {
      TableName: 'user_groups' + dynamodbSuffix,
      Key: { 'groupId': groupId },
      UpdateExpression: 'SET allowedAt = :now, closedAt = :null',
      ExpressionAttributeValues: {
        ':now': now,
        ':null': ''
      },
      ReturnValues: 'UPDATED_NEW'
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials),
          convertEmptyValues: true
        })
        return docClient.update(params).promise()
      })
      .then(data => {
        logger.debug('update:', data)
        return data
      })
  },
  async closeUserGroup ({ commit, state }, { groupId }) {
    logger.debug('store::closeUserGroup', groupId)
    let now = moment().tz('Asia/Tokyo').format('x')
    var params = {
      TableName: 'user_groups' + dynamodbSuffix,
      Key: { 'groupId': groupId },
      UpdateExpression: 'SET closedAt = :now',
      ExpressionAttributeValues: {
        ':now': now
      },
      ReturnValues: 'UPDATED_NEW'
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.update(params).promise()
      })
      .then(data => {
        logger.debug('update:', data)
        return data
      })
  },
  async deleteUserGroup ({ commit, state }, { groupId }) {
    logger.debug('store::deleteUserGroup', groupId)
    var params = {
      TableName: 'user_groups' + dynamodbSuffix,
      Key: { 'groupId': groupId }
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.delete(params).promise()
      })
      .then(data => {
        logger.debug('deleted:', data)
        return data
      })
  },
  async deleteUserFelica ({ commit, state }, { idm }) {
    logger.debug('store::deleteUserFelica', idm)
    var params = {
      TableName: 'user_felica' + dynamodbSuffix,
      Key: { 'idm': idm }
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.delete(params).promise()
      })
      .then(data => {
        logger.debug('deleted:', data)
        return data
      })
  },
  async deleteUser ({ commit, state }, { userId }) {
    logger.debug('store::deleteUser', userId)
    var params = {
      TableName: 'user_settings' + dynamodbSuffix,
      Key: { 'user_id': userId }
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.delete(params).promise()
      })
      .then(data => {
        logger.debug('deleted:', data)
        return data
      })
  },
  async deleteUserDailyEnquetes ({ commit, state }, { userId, calendarTime }) {
    logger.debug('store::deleteUserDailyEnquetes', userId, calendarTime)
    var params = {
      TableName: 'user_daily_enquetes' + dynamodbSuffix,
      Key: { 'user_id': userId, 'calendarTime': calendarTime }
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.delete(params).promise()
      })
      .then(data => {
        logger.debug('deleted:', data)
        return data
      })
  },
  async removeUserGroup ({ commit, state }, { userSettings, groupId }) {
    logger.debug('store::removeUserGroup', userSettings, groupId)
    let params = {
      TableName: 'user_settings' + dynamodbSuffix,
      Key: { 'user_id': userSettings.user_id },
      UpdateExpression: 'REMOVE userGroups.' + groupId,
      ReturnValues: 'ALL_NEW'
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.update(params).promise()
      })
      .then(data => {
        logger.debug('deleted:', data)
        return data
      })
  },
  async leaveUserGroup ({ commit, state }, { userGroup, userId }) {
    logger.debug('store::leaveUserGroup', userGroup, userId)
    let index = userGroup.members.findIndex(mem => mem.user_id === userId)
    let params = {
      TableName: 'user_groups' + dynamodbSuffix,
      Key: { 'groupId': userGroup.groupId },
      UpdateExpression: 'REMOVE members[' + index + ']',
      ReturnValues: 'ALL_NEW'
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.update(params).promise()
      })
      .then(data => {
        logger.debug('deleted:', data)
        return data
      })
  },
  async fetchUsers ({ commit, state }) {
    var params = {
      TableName: 'user_settings' + dynamodbSuffix
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.scan(params).promise()
      })
      .then(data => {
        var users = []
        data.Items.forEach((user, index) => {
          users.push(user)
        })
        commit('setUsers', { users })
        return users
      })
  },
  async fetchUser ({ commit, state }, { userId }) {
    var params = {
      TableName: 'user_settings' + dynamodbSuffix,
      Key: { 'user_id': userId }
    }
    logger.debug('store::fetchUser', params)
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.get(params).promise()
      })
      .then(data => {
        let user = data.Item
        user && commit('setUser', { user })
        return user
      })
  },
  async getUserGroup ({ commit, state }, { groupId }) {
    var params = {
      TableName: 'user_groups' + dynamodbSuffix,
      Key: { 'groupId': groupId }
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.get(params).promise()
      })
      .then(data => {
        logger.debug('store::getUserGroup:', data.Item)
        let userGroup = data.Item
        userGroup && commit('setUserGroup', { userGroup })
        return userGroup
      })
  },
  async fetchUserGroups ({ commit, state }) {
    var params = {
      TableName: 'user_groups' + dynamodbSuffix
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.scan(params).promise()
      })
      .then(data => {
        let userGroups = []
        data.Items.forEach((user, index) => {
          userGroups.push(user)
        })
        logger.debug('sort', userGroups)
        userGroups.sort((a, b) => b.scheduledAt < a.scheduledAt)
        logger.debug('sorted', userGroups)
        commit('setUserGroups', { userGroups })
        return userGroups
      })
  },
  async fetchUserFelicas ({ commit, state }) {
    let params = {
      TableName: 'user_felica' + dynamodbSuffix
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.scan(params).promise()
      })
      .then(data => {
        let userFelicas = data.Items
        commit('setUserFelicas', { userFelicas })
        return data.Items
      })
  },
  async createUserFelica ({ commit, state }, { userGroup, idm, name }) {
    logger.debug('store::createUserFelica', userGroup, idm)
    let params = {
      TableName: 'user_felica' + dynamodbSuffix,
      Item: {
        idm: idm,
        groupId: userGroup.groupId,
        userGroup: userGroup,
        name: name,
        user_id: '0',
        userNo: ' ',
        lastModifiedAt: moment().tz('Asia/Tokyo').format('x')
      }
    }
    let params2 = {
      TableName: 'user_groups' + dynamodbSuffix,
      Key: { groupId: userGroup.groupId },
      UpdateExpression: ' SET #idms = list_append(:idm, #idms)',
      ExpressionAttributeNames: {
        '#idms': 'idms'
      },
      ExpressionAttributeValues: {
        ':idm': [idm]
      }
    }
    logger.debug('params2:', params2)
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.put(params).promise().then(data => {
          return docClient.update(params2).promise()
        })
      }).then(data => {
        logger.debug(data)
        return data
      })
  },
  async updateUserFelica ({ commit, state }, { idm, user }) {
    logger.debug('store::updateUserFelica', idm, user)
    let params = {
      TableName: 'user_felica' + dynamodbSuffix,
      Key: { idm: idm },
      UpdateExpression: ' SET user_id = :user_id, userNo = :userNo, lastModifiedAt = :lastModifiedAt',
      ExpressionAttributeValues: {
        ':user_id': user.user_id,
        ':userNo': user.currentUserNo,
        ':lastModifiedAt': moment().tz('Asia/Tokyo').format('x')
      }
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.update(params).promise()
      })
      .then(data => {
        logger.debug(data)
        return data
      })
  },
  async updateUser ({ commit, state }, { userId, name, value }) {
    logger.debug('update user:', userId, name, value)
    let params = {
      TableName: 'user_settings' + dynamodbSuffix,
      Key: {
        user_id: userId
      },
      ExpressionAttributeNames: {
        '#lastModifiedAt': 'lastModifiedAt'
      },
      ExpressionAttributeValues: {
        ':newValue': value || null,
        ':curTime': moment().format('x')
      },
      UpdateExpression: 'SET ' + name + ' = :newValue, #lastModifiedAt = :curTime'
    }
    logger.debug('update user_settings:', params)
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.update(params).promise()
      })
      .then(data => {
        logger.debug(data)
        // commit('setUsers', { users })
        commit('updateUser', { userId, name, value })
        return data
      })
  },
  async editUserDailyEnquetes ({ commit, state }, { userId, calendarTime, ...values }) {
    logger.debug('store::editUserDailyEnquetes', userId, values)

    let exp = []
    let attr = {}
    let vals = {}
    values.values.map((val, index) => {
      exp[index] = `#attr${index} = :newValue${index},`
      attr['#attr' + index] = val.name
      vals[':newValue' + index] = val.value
    })

    let params = {
      TableName: 'user_daily_enquetes' + dynamodbSuffix,
      Key: {
        user_id: userId, calendarTime: calendarTime
      },
      ExpressionAttributeNames: Object.assign({
        '#lastModifiedAt': 'lastModifiedAt'
      }, attr),
      ExpressionAttributeValues: Object.assign({
        ':curTime': moment().format('x')
      }, vals),
      UpdateExpression: 'SET ' + exp.join('') + ' #lastModifiedAt = :curTime'
    }
    logger.debug('store::editUserDailyEnquetes', params)
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.update(params).promise()
      })
      .then(data => {
        logger.debug(data)
        // commit('setUsers', { users })
        return data
      })
  },
  async getS3SignedUrl ({ commit, stete }, { s3path }) {
    logger.debug('getS3SignedUrl:', s3path)
    var params = {
      Bucket: process.env.VUE_APP_S3Bucket_DataPool,
      Key: s3path
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.credentials = credentials
        AWS.config.update({ region: 'ap-northeast-1' })
        AWS.config.apiVersions = { s3: '2006-03-01' }
        return new AWS.S3().getSignedUrl('getObject', params)
      })
      .then(result => {
        logger.debug(result)
        // commit('setUsers', { users })
        return result
      })
  },
  async fetchDailyEnquetes ({ commit, state }, { userId, calendarTime }) {
    if (!userId && !calendarTime) {
      throw new Error('invalid parameter:' + userId + '/' + calendarTime)
    }
    console.log('Dynamodb Key:', userId, calendarTime)
    /*
    let params = {
      TableName: 'user_daily_enquetes',
      FilterExpression: 'calendarTime = :calendarTime',
      ExpressionAttributeValues: {
        ':calendarTime': calendarTime
      }
    }
    */
    let params = {
      TableName: 'user_daily_enquetes' + dynamodbSuffix
    }
    logger.debug('store::fetchDailyEnquetes', params)
    try {
      const credentials = await Auth.currentCredentials()
      AWS.config.update({ region: 'ap-northeast-1' })
      const docClient = new AWS.DynamoDB.DocumentClient({
        apiVersion: '2013-04-01',
        credentials: Auth.essentialCredentials(credentials)
      })
      let items = []

      const scan = async () => {
        const result = await docClient.scan(params).promise()
        items.push(...result.Items)

        if (result.LastEvaluatedKey) {
          params.ExclusiveStartKey = result.LastEvaluatedKey
          await scan()
        }
      }
      await scan()

      logger.debug(`store::fetchDailyEnquetes count=${items.length}`)
      return items
    } catch (err) {
      logger.error('[Error]store::fetchDailyEnquetes', err)
      throw err
    }
  },
  async fetchDailyEnquetesByGroupId ({ commit, state }, { groupId }) {
    if (!groupId) {
      throw new Error('invalid parameter:' + groupId)
    }
    let params = {
      TableName: 'user_daily_enquetes' + dynamodbSuffix,
      FilterExpression: 'userGroupId = :userGroupId',
      ExpressionAttributeValues: {
        ':userGroupId': groupId
      }
    }
    logger.debug('store::fetchDailyEnquetesByGroupId', params)
    try {
      const credentials = await Auth.currentCredentials()
      AWS.config.update({ region: 'ap-northeast-1' })
      const docClient = new AWS.DynamoDB.DocumentClient({
        apiVersion: '2013-04-01',
        credentials: Auth.essentialCredentials(credentials)
      })
      let items = []

      const scan = async () => {
        const result = await docClient.scan(params).promise()
        items.push(...result.Items)

        if (result.LastEvaluatedKey) {
          params.ExclusiveStartKey = result.LastEvaluatedKey
          await scan()
        }
      }
      await scan()

      logger.debug(`store::fetchDailyEnquetesByGroupId count=${items.length}`)
      return items
    } catch (err) {
      logger.error('[Error]store::fetchDailyEnquetesByGroupId', err)
      throw err
    }
  },
  async findUserDailyEnquetes ({ commit, state }, { userId }) {
    if (!userId) {
      throw new Error('invalid parameter:' + userId)
    }
    console.log('Dynamodb Key:', userId)
    let params = {
      TableName: 'user_daily_enquetes' + dynamodbSuffix,
      KeyConditionExpression: 'user_id = :user_id',
      ExpressionAttributeValues: {
        ':user_id': userId
      }
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        const docClient = new AWS.DynamoDB.DocumentClient({
          apiVersion: '2013-04-01',
          credentials: Auth.essentialCredentials(credentials)
        })
        return docClient.query(params).promise()
      })
      .then(data => {
        logger.debug(data)
        return data.Items
      })
  },
  async fetchCognitoUsers ({ commit, state }, { paginationToken }) {
    var params = {
      UserPoolId: process.env.VUE_APP_COGNITO_UserPoolId,
      PaginationToken: paginationToken,
      Limit: 60
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        let cognito = new AWS.CognitoIdentityServiceProvider({
          apiVersion: '2016-04-18',
          credentials: Auth.essentialCredentials(credentials)
        })
        return cognito.listUsers(params).promise()
      })
      .then(data => {
        /*
        var userGroups = []
        data.Users.forEach((user, index) => {
          userGroups.push(user)
        })
        commit('setUserGroups', { userGroups })
        */
        return data
      })
  },
  async createCognitoUser ({ commit, state }, { newUser }) {
    logger.debug('store::createCognitoUser', newUser)
    let params = {
      UserPoolId: process.env.VUE_APP_COGNITO_UserPoolId,
      Username: newUser.email,
      TemporaryPassword: newUser.password,
      UserAttributes: [
        { 'Name': 'email', 'Value': newUser.email },
        { 'Name': 'nickname', 'Value': newUser.username }
      ]
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        let cognito = new AWS.CognitoIdentityServiceProvider({
          apiVersion: '2016-04-18',
          credentials: Auth.essentialCredentials(credentials)
        })
        return cognito.adminCreateUser(params).promise()
      })
      .then(data => {
        logger.debug(data)
        return data
      })
      .catch(err => {
        logger.debug(err)
        if (err['errorType'] === 'UsernameExistsException') {
          return 'ユーザー名が既に存在します。'
        } else {
          return err['errorMessage']
        }
      })
  },
  async deleteCognitoUser ({ commit, state }, { username }) {
    logger.debug('store::deleteCognitoUser', username)
    if (!username) {
      throw new Error('invalid parameter ' + username)
    }
    console.log('Congnito Key:' + username)
    let params = {
      UserPoolId: process.env.VUE_APP_COGNITO_UserPoolId,
      Username: username
    }
    return Auth.currentCredentials()
      .then(credentials => {
        AWS.config.update({ region: 'ap-northeast-1' })
        let cognito = new AWS.CognitoIdentityServiceProvider({
          apiVersion: '2016-04-18',
          credentials: Auth.essentialCredentials(credentials)
        })
        return cognito.adminDeleteUser(params).promise()
      })
      .then(data => {
        logger.debug(data)
        return data
      })
  }
}

const getters = {
  users: state => state.users,
  userGroups: state => state.userGroups,
  userFelicas: state => state.userFelicas,
  currentUser: state => state.currentUser,
  currentUserGroup: state => state.currentUserGroup
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  // Head,
  strict: debug
})
